/*
 * IMPORTS
 */
import { gql } from '@apollo/client'

/*
 * EXPORTS
 */
export default gql`
  query PhoneNumberoRouteReadQuery($routeId: ID!) {
    PhoneNumberoRouteRead(routeId: $routeId) {
      id
      displayName
      type
      CustomerAccount {
        id
        displayName
      }
    }
  }
`
